import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'commaSeparatedNumber'})
export class CommaSeparatedNumberPipe implements PipeTransform {
  transform(value:number, args:string[]) : any {
    return (value !=null) ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : value; // '12,000';Convert number to comma separated number string
  }
}